module.exports = __webpack_public_path__ + "img/pmx.380b61c8.jpg";